const { safePath } = require("./tracking-policy");
const { isThankYouPage } = require("./analytics-privacy");

function performanceEvent(event, context) {
  if (!context.allowed || event?.type !== "vital" || !context.route ||
    ["/404", "/500", "/_error"].includes(context.route) || isThankYouPage(context.path)) return null;
  try {
    const url = new URL(event.url);
    const path = safePath(url.pathname);
    if (!["http:", "https:"].includes(url.protocol) || url.username || url.password ||
      url.origin !== context.origin || url.pathname !== path || path !== context.path ||
      !/^\/[a-z0-9_./[\]-]*$/i.test(context.route)) return null;
    return { type: event.type, url: `${url.origin}${path}`, route: context.route };
  } catch { return null; }
}

function diagnosticOrigin(input) {
  try {
    const url = new URL(input);
    return url.protocol === "https:" && !url.username && !url.password &&
      ["digifist.com", "www.digifist.com", "digifist.com.tr", "www.digifist.com.tr"].includes(url.hostname)
      ? url.origin : "https://www.digifist.com";
  } catch { return "https://www.digifist.com"; }
}

function diagnosticFile(input) {
  try {
    const url = new URL(input);
    if (url.origin !== diagnosticOrigin(input) || !/^\/_next\/static\/[a-z0-9_./[\]-]+\.(?:js|mjs)$/i.test(url.pathname)) return "[redacted]";
    return `${url.origin}${url.pathname}`;
  } catch { return "[redacted]"; }
}

function sanitizeBreadcrumb(breadcrumb) {
  if (!["navigation", "request"].includes(breadcrumb.type)) return false;
  const metadata = breadcrumb.metadata || {};
  breadcrumb.message = breadcrumb.type === "navigation" ? "Navigation" : "Request";
  breadcrumb.metadata = {
    origin: diagnosticOrigin(metadata.url || metadata.to || metadata.from),
    ...(typeof metadata.method === "string" && /^(?:GET|HEAD|POST|PUT|PATCH|DELETE|OPTIONS)$/.test(metadata.method) ? { method: metadata.method } : {}),
    ...(Number.isInteger(metadata.status) && metadata.status >= 100 && metadata.status <= 599 ? { status: metadata.status } : {}),
  };
  return true;
}

function sanitizeError(event) {
  try {
    event.context = "DigiFist frontend";
    event.request = { url: `${diagnosticOrigin(event.request?.url)}/`, clientIp: "[REDACTED]" };
    event.response = {};
    event.setUser("[REDACTED]");
    // Use the SDK's public serialization and metadata removal methods; do not
    // retain even arbitrary metadata section/key names from an exception.
    for (const section of Object.keys(event.toJSON().metaData || {})) event.clearMetadata(section);
    event.clearFeatureFlags();
    event.groupingHash = undefined;
    event.setGroupingDiscriminator(undefined);
    event.device = event.device?.time instanceof Date ? { time: event.device.time } : {};
    event.breadcrumbs = (event.breadcrumbs || []).filter(sanitizeBreadcrumb);
    event.errors = (event.errors || []).map(error => ({
      errorClass: ["Error", "TypeError", "ReferenceError", "RangeError", "SyntaxError", "URIError", "EvalError", "AggregateError"].includes(error.errorClass) ? error.errorClass : "Error",
      errorMessage: "Error details redacted",
      type: "browserjs",
      stacktrace: (error.stacktrace || []).map(frame => ({
        file: diagnosticFile(frame.file),
        ...(Number.isInteger(frame.lineNumber) ? { lineNumber: frame.lineNumber } : {}),
        ...(Number.isInteger(frame.columnNumber) ? { columnNumber: frame.columnNumber } : {}),
      })),
    }));
    return true;
  } catch { return false; }
}

// No arbitrary metadata values leave the browser. The explicit field matcher
// documents the sensitive fields; the final catch-all also covers SDK-added
// metadata and unknown CMS/custom form names at delivery time.
const redactedKeys = [/password|secret|token|authorization|cookie|email|name|phone|company|message|form|body|query|address/i, /./];
module.exports = { performanceEvent, sanitizeBreadcrumb, sanitizeError, redactedKeys };
